import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

const SvgHash01 = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4 8h16M4 16h16M8 3v18m8-18v18"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgHash01)
export default ForwardRef
